import { render } from "./SlideBar.vue?vue&type=template&id=4d5f0afa&scoped=true"
import script from "./SlideBar.vue?vue&type=script&lang=js"
export * from "./SlideBar.vue?vue&type=script&lang=js"

import "./SlideBar.vue?vue&type=style&index=0&id=4d5f0afa&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5f0afa"]])

export default __exports__